import React, { Component } from 'react';

import EmisorFiscalCredentials from './EmisorFiscalCredentials';
import EmisorFiscalCredentialslInfo from './EmisorFiscalCredentialslInfo';

class EmisorCsdForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      isValid: !!props.data.rfc,
    };
  }

  get inputs() {
    return {
      key: {
        name: 'csd_key',
        label: 'CSD .key',
      },
      cer: {
        name: 'csd_cer',
        label: 'CSD .cer',
      },
      password: {
        name: 'csd_password',
        label: 'Contraseña del CSD',
      },
    };
  }

  handleOnChange = (value) => {
    const { isValid } = this.state;
    const data = {
      ...this.props.data,
      ...value,
    };

    this.props.onFormDataChange({
      data,
      step: 'csd',
      isValid: !!isValid,
    });
  };

  handleOnFiscalCredentialsChange = (event) => {
    this.setState(
      {
        isValid: event.isValid,
      },
      () => {
        this.handleOnChange(event.data);
      }
    );
  };

  handleOnAction = () => {
    this.setState({
      ...this.state,
      error: undefined,
    });
  };

  render() {
    const { data, confirm } = this.props;
    const { isValid } = this.state;

    return (
      <>
        {!isValid && (
          <EmisorFiscalCredentials
            type="CSD"
            inputs={this.inputs}
            data={data}
            confirm={confirm}
            onFormDataChange={this.handleOnFiscalCredentialsChange}
          />
        )}

        {!!isValid && <EmisorFiscalCredentialslInfo data={data} />}
      </>
    );
  }
}

export default EmisorCsdForm;
